export const CLASS_METADATA_KEY = "$classMetadata";

export interface ClassMetadata
{
    logPropertyName?: string | symbol;
}
